import React from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import DraggableColumn from "../DraggableColumn/DraggableColumn";

const ReorderColumnsSection = ({ allColumns, setAllColumns, handleSelectColumn }) => {
  const onDragEnd = ({ draggableId, source, destination }) => {
    // dropped outside the list
    if (!destination) {
      return;
    }
    setAllColumns((columns) => {
      const top = source.index < destination.index ? source.index : destination.index;
      const bottom = source.index > destination.index ? source.index : destination.index;

      const newColumns = columns.map((column) => {
        const { index } = column;
        if (index < top || index > bottom) {
          return column;
        }
        if (index === source.index) {
          return { ...column, index: destination.index };
        } else {
          if (destination.index < source.index) {
            return { ...column, index: index + 1 };
          } else {
            return { ...column, index: index - 1 };
          }
        }
      });
      return newColumns;
    });
  };

  return (
    <DragDropContext onDragEnd={(result) => onDragEnd(result)}>
      <Droppable droppableId="column-droppable-id">
        {(provided, snapshot) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {[...allColumns]
              .sort((column1, column2) => (column1.index > column2.index ? 1 : -1))
              .map(({ id, title, selected, index }) => {
                if (selected) {
                  return (
                    <Draggable key={id} index={index} draggableId={id}>
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={{
                            userSelect: "none",
                            padding: "6px 0px",
                            ...provided.draggableProps.style,
                          }}
                        >
                          <DraggableColumn
                            {...{
                              id,
                              title,
                              handleSelectColumn,
                            }}
                          />
                        </div>
                      )}
                    </Draggable>
                  );
                } else {
                  return null;
                }
              })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default ReorderColumnsSection;
